import type { NavigationItem } from '../../tokens/navigationPaths';

export function getInitialAddSpaceGroup(
  groups: readonly NavigationItem[] | undefined,
  pathname: string,
  currentLayoutGroup: string | undefined
): string | undefined {
  return getStaticGroupLabelForPath(groups, pathname) ?? normalizeGroup(currentLayoutGroup);
}

function getStaticGroupLabelForPath(
  groups: readonly NavigationItem[] | undefined,
  pathname: string
): string | undefined {
  for (const group of groups ?? []) {
    if (group.label != null && group.label !== '' && navigationItemMatchesPath(group, pathname)) {
      return group.label;
    }
  }
  return undefined;
}

function navigationItemMatchesPath(item: NavigationItem, pathname: string): boolean {
  if (pathMatches(item.path, pathname)) {
    return true;
  }
  const children = item.children as readonly NavigationItem[] | undefined;
  return children?.some(child => navigationItemMatchesPath(child, pathname)) ?? false;
}

function pathMatches(path: string | undefined, pathname: string): boolean {
  if (path == null) {
    return false;
  }
  const basePath = path.endsWith('/*') ? path.slice(0, -2) : path;
  return pathname === basePath || pathname.startsWith(`${basePath}/`);
}

function normalizeGroup(group: string | undefined): string | undefined {
  return group == null || group === '' ? undefined : group;
}
